// Diagnostic Ozentya : questions -> routine (soins à l'unité) + pack conseillé. Ton cosmétique, sans promesse médicale.
export const NEEDS = [
  { id: "cheveux", label: "Mes cheveux", hint: "Pousse, chute, casse, boucles, cuir chevelu" },
  { id: "locks", label: "Mes locks", hint: "Démangeaisons, pousse, entretien" },
  { id: "barbe", label: "Ma barbe", hint: "Barbe clairsemée ou entretien" },
  { id: "enfant", label: "Les cheveux de mon enfant", hint: "Démêlage en douceur" },
  { id: "peau", label: "Ma peau", hint: "Visage et corps" },
];

export const CONCERNS = {
  cheveux: [
    { id: "chute", label: "Mes cheveux tombent ou sont clairsemés" },
    { id: "tempes", label: "Mes tempes ou mes bords sont dégarnis" },
    { id: "casse", label: "Mes cheveux cassent et sont secs" },
    { id: "pellicules", label: "Pellicules ou cuir chevelu qui gratte" },
    { id: "boucles", label: "Je veux des boucles définies et faciles à démêler" },
  ],
  locks: [
    { id: "demangeaisons", label: "Mes locks démangent ou sentent le renfermé" },
    { id: "pousse", label: "Je veux faire pousser mes locks" },
    { id: "entretien", label: "Je veux des locks nettes et brillantes" },
  ],
  barbe: [
    { id: "pousse", label: "Ma barbe est clairsemée ou pousse mal" },
    { id: "entretien", label: "Je veux une barbe douce et bien entretenue" },
  ],
  peau: [
    { id: "eclat", label: "Je veux un teint plus lumineux" },
    { id: "purifier", label: "Ma peau a besoin d'être purifiée" },
    { id: "corps", label: "Je cherche un soin pour le corps" },
  ],
};

export const LEVELS = [
  { id: "essentiel", label: "L'essentiel", hint: "Je débute, une routine simple" },
  { id: "complet", label: "Une routine complète", hint: "Je veux mettre toutes les chances de mon côté" },
  { id: "intensif", label: "Une cure de 3 mois", hint: "Je m'engage sur la durée, le plus économique" },
];

export const needsLevel = (need, concern) => need === "cheveux" && (concern === "chute" || concern === "tempes");

const R = (title, text, units, pack) => ({ title, text, units, pack });

/** Returns { title, text, units: [slug], pack: slug|null } */
export function routineFor({ need, concern, fine, level }) {
  if (need === "cheveux") {
    if (concern === "chute" || concern === "tempes") {
      if (fine) return R("Routine Pousse Cheveux Fins", "Des soins pensés pour prendre soin du cuir chevelu sans alourdir les cheveux fins, à appliquer avec régularité.", ["shampoing-cactus", "extreme-repouss-cheveux-fins", "traitement-3-extreme-pouss-fins"], "pack-cheveux-fins");
      const pack = { essentiel: "pack-pouss-initial", complet: "pack-pouss-optimal", intensif: "cure-3-mois-8-soins" }[level] || "pack-pouss-initial";
      const units = concern === "tempes" ? ["extreme-repouss", "traitement-3-extreme-pouss", "edge-control"] : ["shampoing-cactus", "extreme-repouss", "traitement-3-extreme-pouss"];
      return R(concern === "tempes" ? "Routine Tempes & Bords" : "Routine Pousse", "Une routine Ozentya qui nourrit le cuir chevelu et accompagne la pousse. La régularité est la clé : comptez plusieurs semaines d'application.", units, pack);
    }
    if (concern === "casse") return R("Routine Anti-casse", "Pour renforcer la fibre, nourrir en profondeur et limiter la casse au coiffage.", ["creme-reconstructrice-cactus", "serum-reconstructeur", "masque-supreme", "apres-shampoing-ricin-jojoba"], null);
    if (concern === "pellicules") return R("Routine Cuir chevelu apaisé", "Pour nettoyer en douceur, réduire l'apparence des pellicules et apaiser les démangeaisons.", ["shampoing-anti-pelliculaire", "apres-shampoing-ricin-jojoba"], null);
    return R("Routine Boucles définies", "Pour des boucles hydratées, faciles à démêler et bien dessinées.", ["shampoing-natyrel", "masque-demelant-natyrel", "gel-definition-boucles"], null);
  }
  if (need === "locks") {
    if (concern === "demangeaisons") return R("Routine Locks Fraîcheur", "Pour un cuir chevelu propre, apaisé et des locks qui sentent bon.", ["shampoing-expert-locks", "spray-locks"], "pack-locks-ultime");
    if (concern === "pousse") return R("Routine Pousse Locks", "Pour nourrir le cuir chevelu et accompagner la pousse de vos locks.", ["shampoing-expert-locks", "huile-locks"], "pack-pouss-locks");
    return R("Routine Locks Nettes", "Pour des locks bien tenues, nourries et brillantes.", ["gel-locks", "huile-locks", "spray-locks"], "pack-locks-ultime");
  }
  if (need === "barbe") {
    if (concern === "pousse") return R("Routine Pousse Barbe", "Pour nourrir les poils et la peau dessous, et accompagner une barbe plus fournie.", ["shampoing-barbe", "huile-barbe"], "pack-barbe");
    return R("Routine Barbe Parfaite", "Pour une barbe propre, douce et disciplinée au quotidien.", ["shampoing-barbe", "huile-barbe"], "routine-barbe");
  }
  if (need === "enfant") return R("Routine Kids", "Des soins doux pour laver et démêler sans tirer, adaptés aux cheveux des enfants.", ["shampoing-argan", "creme-demelante-junior"], "pack-kids");
  if (concern === "eclat") return R("Routine Éclat", "Pour un teint plus lumineux et une peau nourrie.", ["creme-visage-sublime-eclat"], null);
  if (concern === "purifier") return R("Routine Peau Purifiée", "Pour désincruster en douceur et retrouver une peau nette.", ["masque-argile"], null);
  return R("Routine Corps", "Pour une peau propre, douce et délicatement parfumée.", ["gel-douche-exaltant"], null);
}
